<ng-container *transloco="let t; read: 'home.calculator'">
  <div *ngIf="hourlySolarCalculatorResult" @inOutAnimation class="flex flex-col gap-10 items-stretch">

    <psc-solar-assessment
      [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-solar-assessment>

    <psc-annual-hourly-chart
      [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-annual-hourly-chart>

    <psc-yearly-savings
      [powerPlant]="powerPlant"
      [extendedData]="true"
      [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-yearly-savings>

    <psc-return-on-investment-chart
      [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-return-on-investment-chart>

    <psc-peak-power-chart
      [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-peak-power-chart>

    <psc-user-investment
      [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-user-investment>

  <psc-monthly-results-wrapper
    [solarCalculatorResult]="hourlySolarCalculatorResult"></psc-monthly-results-wrapper>
  </div>

</ng-container>
